import { Decimal } from './decimal';

/**
 * Deep clone for plain game state. Decimals are treated as immutable values and shared.
 * Sets/Maps never appear in persisted state. Hot path (every command clones the state), so it
 * avoids per-object allocations beyond the copies themselves.
 */
export function deepClone<T>(v: T): T {
  if (v === null || typeof v !== 'object') return v;
  if (v instanceof Decimal) return v;
  if (Array.isArray(v)) {
    const n = v.length;
    // Arrays of primitives (strips, stops, flags, ids) copy flat.
    if (n === 0 || typeof v[0] !== 'object' || v[0] === null) {
      let flat = true;
      for (let i = 0; i < n; i++) if (typeof v[i] === 'object' && v[i] !== null) flat = false;
      if (flat) return v.slice() as T;
    }
    const out = new Array(n);
    for (let i = 0; i < n; i++) out[i] = deepClone(v[i]);
    return out as T;
  }
  const src = v as Record<string, unknown>;
  const out: Record<string, unknown> = {};
  for (const k in src) out[k] = deepClone(src[k]);
  return out as T;
}
